export default function brand_details()
{
    return({
        //Company Information
        name: "Empire Partner Foundation",
        subtitle: "Visual Social Impact",
        sub_entity_name: "REimagine",

        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
}